import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectTo = "/dashboard",
}) => {
  const { user, loading, justRegistered } = useAuth();

  // Check if user is in password reset flow
  const isResettingPassword =
    sessionStorage.getItem("isResettingPassword") === "true";

  // Don't redirect if user is resetting password
  if (isResettingPassword) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#eeeff6]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primarycolor-1 mx-auto mb-4"></div>
          <p className="text-[#373e46] font-medium">Memuat...</p>
        </div>
      </div>
    );
  }

  // Only redirect if user is logged in AND they haven't just registered
  if (user && !justRegistered) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
